/* eslint-disable no-param-reassign */
const gallery = () => {
  const setImage = (images, popupImage, imgIndex) => {
    images.forEach((el, index) => {
      if (parseInt(imgIndex, 10) === index) {
        const { img } = el.dataset;
        popupImage.src = img;
      }
    });
  };

  const showPopup = () => {
    const images = document.querySelectorAll('.js-gallery-img');

    if (images) {
      const popup = document.querySelector('.js-gallery-popup');
      const popupImage = popup.querySelector('.js-gallery-popup img');
      const close = document.querySelector('.js-gallery-close');
      const prev = document.querySelector('.js-gallery-prev');
      const next = document.querySelector('.js-gallery-next');
      let currentIndex = null;

      images.forEach((image, index) => {
        image.addEventListener('click', () => {
          const { img } = image.dataset;
          currentIndex = index;
          popupImage.src = img;
          setTimeout(() => {
            popup.classList.remove('u-hidden');
          }, 400);
        });
      });

      close.addEventListener('click', () => {
        popup.classList.add('u-hidden');
        popupImage.src = null;
      });

      prev.addEventListener('click', () => {
        if (currentIndex === 0) {
          currentIndex = images.length - 1;
        } else {
          currentIndex -= 1;
        }
        setImage(images, popupImage, currentIndex);
      });

      next.addEventListener('click', () => {
        if (currentIndex === images.length - 1) {
          currentIndex = 0;
        } else {
          currentIndex += 1;
        }
        setImage(images, popupImage, currentIndex);
      });
    }
  };

  showPopup();
  document.showPopup = showPopup;
};

export default gallery;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/gallery.js